import  { FC, useEffect, useState } from "react"
import s from "./styles.module.css"
import EventMap from "@pages/makeEvent/event-map"
import { useRegionAutocomplete } from "@shared/autocomplete-location/useRegionAutocomplete"
import { useAddressAutocomplete } from "@shared/autocomplete-location/useAddressLocation"
import { AddressLocation } from "@app/data/location/schema";
import { addressToMap } from "./utils"
import { AddressSchema } from "./schema"
import AutocompleteInputAddress from "./autocompleteInputAddress"
import {
  labelOfAddress,
  labelOfRegion,
} from "./autocompleteInputAddress/labelOfAddress"
import { AutocompleteChangeReason } from "@mui/material"
import { CityItem, OptionsItem } from "./autocompleteInputAddress/OptionsItem"
import { EventAddressDto } from "@app/data/tribeSwaggerApi"
import { defaultCityList } from "./defaultCityList"
import { useAppDispatch } from "@app/hooks";
import { apply } from "@app/data/createEvent/createEventSlice";
import { AddressComponentProps } from '@pages/makeEvent/types'


const AddressComponent: FC<AddressComponentProps> = ({ formik, setValidAddress }) => {
  const dispatch = useAppDispatch()
  const { event_address } = formik.values
  const [currentCity, setCurrentCity] = useState<AddressLocation | null>(null)
  const [currentAddress, setCurrentAddress] =
    useState<EventAddressDto>(event_address)
  const isValidAddress =  AddressSchema.safeParse(currentAddress).success

  useEffect(() => {
    if (isValidAddress) {
      setValidAddress(currentAddress)
    } else {
      setValidAddress(null)
    }
  } , [isValidAddress])

  const {
    cityList: cityList,
    search,
    isLoading,
  } = useRegionAutocomplete()
  const {
    isLoading: isAddressListLoading,
    addressList,
    search: addressSearch,
  } = useAddressAutocomplete()
  const [addressInputError, setAddressInputError] = useState<string>("")
  const [regionInputError] = useState<string>("")

  const inputAddressChangeHandler = (input: string) => {
    if (currentCity) {
      addressSearch(currentCity, input)
    }
  }
  const inputRegionChangeHandler = (input: string) => {
    if (input.trim() !== "") {
      search(input)
    }
  }

  const onChangeAddress = (
    value: AddressLocation | null,
    reason: AutocompleteChangeReason,
    isFullAddress: boolean,
  ) => {
    if (isFullAddress && value && reason === "selectOption") {
      setCurrentAddress((prevState) => {

        const newAddress =   {
        ...prevState,
        street: `${value.street_type}. ${value.street}`,
        house_number: value.house,
        event_longitude: Number.parseFloat(value.lon),
        event_latitude: Number.parseFloat(value.lat),
      }
        dispatch(apply({
          event_address: newAddress
        }))
        formik.setFieldValue('event_address', newAddress)
      return newAddress
      })

      setAddressInputError("")
    }
    if (!isFullAddress && value) {
      setAddressInputError("Введите полный адрес")
    }
    if (reason === "clear") {
      setAddressInputError("")
    }
  }
  const onChangeRegion = (
    value: AddressLocation | null,
    reason: AutocompleteChangeReason,
  ) => {
    if (reason === "selectOption") {
      setCurrentCity(value)
      if (value) {
        setCurrentAddress((prev: EventAddressDto) => ({
          ...prev,
          region: `${value.region_type}. ${value.region}`,
          city:
            value.settlement.trim() === ""
              ? `${value.city_type}. ${value.city}`
              : `${value.settlement_type}. ${value.settlement}`,
        }))
      }
    }
    if (reason === "clear") {
      setCurrentCity(null)
    }
  }

  return (
    <div className={s.content}>
      <AutocompleteInputAddress
        labelBuilder={labelOfRegion}
        valueForInput={event_address.city}
        isLoading={isLoading}
        addressList={cityList}
        placeholder={"Выберите город"}
        defaultList={defaultCityList}
        optionBuilder={CityItem}
        onChange={onChangeRegion}
        onInputChange={inputRegionChangeHandler}
        errorText={regionInputError}
      />
      <AutocompleteInputAddress
        labelBuilder={labelOfAddress}
        valueForInput={`${event_address.street} ${event_address.house_number}`}
        isLoading={isAddressListLoading}
        addressList={addressList}
        placeholder={"Выберите адрес"}
        optionBuilder={OptionsItem}
        onChange={onChangeAddress}
        onInputChange={inputAddressChangeHandler}
        errorText={addressInputError}
      />
      <div className={s.map}>
        <EventMap location={addressToMap(currentAddress)} />
      </div>
    </div>
  )
}

export default AddressComponent
